
import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface BrandGuidelinesTextSectionProps {
  brandGuidelines: string;
  updateBusinessData: (key: string, value: any) => void;
}

const BrandGuidelinesTextSection: React.FC<BrandGuidelinesTextSectionProps> = ({ 
  brandGuidelines, 
  updateBusinessData 
}) => {
  const onChange = (value: string) => {
    updateBusinessData('brandGuidelines', value);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="brand-guidelines">Brand Guidelines</Label>
      <Textarea
        id="brand-guidelines"
        placeholder="Share key points from your brand guidelines..."
        className="resize-none"
        rows={5}
        value={brandGuidelines}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default BrandGuidelinesTextSection;
